import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-annual-school-profiles-form-card',
  templateUrl: './annual-school-profiles-form-card.component.html',
  standalone: true,
  imports: [
    FormsModule,
    NgForOf
  ],
  styleUrl: './annual-school-profiles-form-card.component.css'
})

export class AnnualSchoolProfilesFormCardComponent {
  @Input() name: string = '';
  @Input() email: string = '';
  @Input() teacherList: any[] = [];
  @Output() nameChange = new EventEmitter<string>();
  @Output() delete = new EventEmitter<void>();
  @Input() number: number = 1;
}
